import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaFacebookF, FaInstagram, FaWhatsapp, FaTiktok, FaGoogle, FaTripadvisor, FaPaperPlane } from "react-icons/fa";

const Footer = () => {
    return (
        <footer className="bg-dark text-light py-5">
            <div className="container">
                <div className="row">

                    {/* Left Section */}
                    <div className="col-md-4 mb-4 mb-md-0 text-center text-md-start">
                        <h3 className="fw-bold">CINNAMON MANTRA<span className="text-warning">.</span></h3>
                        <p className="fw-bold" style={{ color: 'white' }}>
                            Ayurveda Spa & Luxury Villa
                        </p>
                        {/* Social Icons */}
                        <div className="d-flex justify-content-center justify-content-md-start gap-3">
                            <a href="https://web.facebook.com/profile.php?id=61573172313018" className="text-light fs-5" target="_blank" rel="noopener noreferrer">
                                <FaFacebookF />
                            </a>
                            <a href="https://www.instagram.com/cinnamon_mantra/" className="text-light fs-5" target="_blank" rel="noopener noreferrer">
                                <FaInstagram />
                            </a>
                            <a href="https://wa.me/+94769072745" className="text-light fs-5" target="_blank" rel="noopener noreferrer">
                                <FaWhatsapp />
                            </a>
                            <a href="https://www.tiktok.com/@cinnamon_mantra?lang=en" className="text-light fs-5" target="_blank" rel="noopener noreferrer">
                                <FaTiktok />
                            </a>
                            <a href="https://www.google.com/search?q=Ayurveda+Wellness+Spa+Cinnamon+Mantra&oq=Ayu&gs_lcrp=EgZjaHJvbWUqCAgAEEUYJxg7MggIABBFGCcYOzIGCAEQRRg5MgYIAhBFGEAyBggDEEUYOzIGCAQQRRg7MgYIBRAjGCcyCggGEAAYsQMYgAQyBwgHEAAYgATSAQoxMTI2NGowajE1qAIAsAIA&sourceid=chrome&ie=UTF-8#lrd=0x3ae22f4900f8aeb5:0x515dedf090dc75a4,3,,,," className="text-light fs-5" target="_blank" rel="noopener noreferrer">
                                <FaGoogle />
                            </a>
                            <a href="https://www.tripadvisor.com/Profile/Cinnamon_Mantra" className="text-light fs-5" target="_blank" rel="noopener noreferrer">
                                <FaTripadvisor />
                            </a>
                        </div>
                    </div>

                    {/* Middle Section - Contact Info */}
                    <div className="col-md-4 mb-4 mb-md-0 text-center text-md-start">
                        <h6 className="text-warning fw-bold">CONTACT US</h6>
                        <p className="mb-1">+94 77 576 1468</p>
                        <p className="mb-1">+94 76 907 2745</p>
                        <p className="mb-1">cinnamonmantra@gmail.com</p>
                        <p>221, 7th Lane, Beruwala 12070, Sri Lanka</p>
                        <p>6th Lane, Police Bungalow Rd, Beruwala 12070</p>
                    </div>

                    {/* Right Section - Newsletter */}
                    <div className="col-md-4 text-center text-md-start">
                        <h6 className="text-warning fw-bold">NEW LATEST</h6>
                        <p>Get the latest updates and offers.</p>
                        <div className="input-group">
                            <input
                                type="email"
                                className="form-control bg-secondary text-light border-0"
                                placeholder="Email"
                            />
                            <button className="btn btn-warning" type="submit">
                                <FaPaperPlane />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Bottom Section */}
                <div className="text-center mt-4 border-top pt-3">
                    <ul className="list-inline mb-2 footer-links">
                        <li className="list-inline-item"><a href="/" className="text-light text-decoration-none">Villa</a></li>
                        <li className="list-inline-item"><a href="/" className="text-light text-decoration-none">Ayurveda-Spa</a></li>
                        <li className="list-inline-item"><a href="/" className="text-light text-decoration-none">About</a></li>
                        <li className="list-inline-item"><a href="/" className="text-light text-decoration-none">Gallery</a></li>
                    </ul>

                    <p className="fw-bold" style={{ color: 'white' }}>
                        Copyright &copy; 2025 All rights reserved Cinnamon Mantra Ayurveda Spa & Luxury Villa PVT LTD
                    </p>
                    <p className="text-warning">
                        Developed by{' '}
                        <a
                            href="https://wa.me/94764608225"
                            className="text-warning text-decoration-none"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Ricky Fernando
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;